import { gql } from '@apollo/client';

export const CRM_BOARD_FIELDS = `
    _id
    name
    order
    status
    createdAt
    updatedAt
`;

export const LIST_CRM_BOARDS = gql`
    query ListCrmBoards {
        listCrmBoards {
            ${CRM_BOARD_FIELDS}
        }
    }
`;

export const GET_CRM_JOURNEY_BOARD = gql`
    query GetCrmJourneyBoard($boardId: String!) {
        getCrmJourneyBoard(boardId: $boardId) {
            _id
            name
            order
            status
            pipelines {
                _id
                boardId
                name
                order
                stages {
                    key
                    name
                    order
                    color
                    isWon
                    isLost
                    description
                    statuses {
                        label
                        fromDays
                        toDays
                        color
                    }
                    tiles {
                        automationId
                        name
                        status
                        audienceType
                        order
                        enrolledCount
                    }
                    contacts {
                        _id
                        accountId
                        firstName
                        lastName
                        email
                        phone
                        status
                    }
                    businesses {
                        _id
                        businessName
                        contactName
                        daysOnStage
                        automations {
                            automationId
                            name
                            isComplete
                        }
                        linkedBusinessId
                    }
                }
            }
        }
    }
`;

export const LIST_AUTOMATION_ENROLLMENTS = gql`
    query ListAutomationEnrollments($automationId: String!, $status: String) {
        listAutomationEnrollments(automationId: $automationId, status: $status) {
            accountId
            contactId
            businessName
            stageKey
            status
            completedAt
            enrolledAt
            progress {
                currentStepIndex
                totalSteps
                currentStepLabel
                nextRunAt
            }
            contacts {
                _id
                firstName
                lastName
                email
                phone
                isPrimary
            }
        }
    }
`;
